// @flow
import React from 'react';
import { useTranslation } from 'react-i18next';

import Tooltip from 'app/common/ui/Tooltip';
import IconIndividual from 'app/common/icons/individual.svg';
import IconCollective from 'app/common/icons/collective.svg';

import styles from './Individual.module.scss';;


type Props = {
  individual: boolean,
}

const Individual = ({ individual }: Props) => {
  const { t } = useTranslation('cafeteria');

  return (individual
    ? <Tooltip text={t('purchase_individual', 'Индивидуальная покупка')}>
      <IconIndividual className={styles.icon} />
    </Tooltip>
    : <Tooltip text={t('purchase_collective', 'Коллективная покупка')}>
      <IconCollective className={styles.icon} />
    </Tooltip>
  );
};

export default Individual;
